import { ResponseSalesAggregate } from './../../models/ResponseSalesAggregate';
import { Component, OnInit } from '@angular/core';
import moment from 'moment/moment';
import {
  concatMap,
  map,
  Observable,
  of,
  shareReplay,
  tap,
} from 'rxjs';
import { HttpService } from 'src/app/services/http/http.service';
import { pageData } from './report-routing.module';
import { ExportService } from 'src/app/services/export/export.service';
import { ApiUrl } from 'src/app/models/ApiUrl';
import { Sort } from '@angular/material/sort';
import { Constants } from "@dealpos-npm/ng-dealpos-library/constants";

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnInit {
  public pageData = pageData;
  public loader$: Observable<{
    From: Date | null;
    To: Date | null;
    PageNumber: number;
    PageSize: number;
  }>;
  private readonly loaderEndpoint = 'Report/GetLoader';
  public data$: Observable<ResponseSalesAggregate>;
  public originalData$: Observable<ResponseSalesAggregate>;
  private readonly dataEndpoint = 'Report/GetReport';

  title$: Observable<string> = of('');

  constructor(
    private http: HttpService,
    private exportService: ExportService
  ) {}

  ngOnInit(): void {
    this.loader$ = this.http
      .post<{
        Filter: { Date: Date | null; PageNumber: number; PageSize: number };
      }>(`/API/${this.loaderEndpoint}`)
      .pipe(
        map((res) => {
          return {
            From: res.Filter.Date,
            To: res.Filter.Date,
            PageNumber: res.Filter.PageNumber || 1,
            PageSize: 150,
          };
        }),
        shareReplay(1)
      );

    this.data$ = this.loader$.pipe(
      concatMap((loader) => this.fetchData$(loader)),
      shareReplay(1)
    );
    this.originalData$ = this.data$;
  }

  onFilterSearch(loader: { From: Date | null; To: Date | null }) {
    this.data$ = this.fetchData$(loader).pipe(shareReplay(1));
    this.originalData$ = this.data$;
  }

  fetchData$(loader: { From: Date | null; To: Date | null }) {
    return this.http
      .post<ResponseSalesAggregate>(`/API/${this.dataEndpoint}`, loader)
      .pipe(
        tap(() => {
          const formattedFrom = moment(loader.From).format('D MMM yyyy');
          const formattedTo = moment(loader.To).format('D MMM yyyy');
          this.title$ = of(
            `Sales Transaction [${
              formattedFrom != formattedTo
                ? formattedFrom + ' - ' + formattedTo
                : formattedFrom
            }]`
          );
        }),
        shareReplay(1)
      );
  }

  public sortData(sort: Sort) {
      if (!sort.active || sort.direction === "") {
        // Reset to original data when no sort is applied
        this.data$ = this.originalData$;
        return;
      }
  
      this.data$ = this.originalData$.pipe(
        map(data => ({
          ...data,
          Data: [...data.Data].sort((a: any, b: any) => {
            return Constants.compare(a[sort.active], b[sort.active], sort.direction === "asc");
          })
        }))
      );
    }

  public onExport(loader: any) {
    this.exportService.exportCSV(ApiUrl.SALES_REPORT_EXPORT, loader);
  }

  public paginationChange(pageNumber: number) {
    this.data$ = this.loader$.pipe(
      concatMap((loader) => {
        loader.PageNumber = pageNumber;
        return this.fetchData$(loader);
      }),
      shareReplay(1)
    );
  }
}
